var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { staticClass: "pa-0" },
    [
      !_vm.loading
        ? _c(
            "v-list-item-group",
            {
              class: { "flex flex-col gap-2": !_vm.loading },
              attrs: { mandatory: "" },
              model: {
                value: _vm.selection,
                callback: function ($$v) {
                  _vm.selection = $$v
                },
                expression: "selection",
              },
            },
            _vm._l(_vm.paymentMethods, function (item) {
              return _c("v-list-item", {
                key: item.id,
                staticClass: "v-sheet--outlined soli-round",
                attrs: { value: item, "two-line": "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ active }) {
                        return [
                          _c(
                            "v-list-item-avatar",
                            [
                              _c("v-img", {
                                attrs: {
                                  src: `/PaymentIcons/${item.brand}.webp`,
                                  alt: item.brand,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            { staticClass: "text-align-start ml-2 py-0" },
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(item.last4)),
                              ]),
                              _vm._v(" "),
                              item.name
                                ? _c("v-list-item-subtitle", [
                                    _vm._v(_vm._s(item.name)),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-list-item-subtitle", [
                                _vm._v(_vm._s(item.exp)),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-item-action", [
                            _c(
                              "div",
                              { staticClass: "flex align-center" },
                              [
                                item.default
                                  ? _c(
                                      "v-list-item-subtitle",
                                      { staticClass: "mr-3" },
                                      [_vm._v("Default")]
                                    )
                                  : _vm._e(),
                                _c("v-icon", { attrs: { color: "accent" } }, [
                                  _vm._v(
                                    _vm._s(
                                      active
                                        ? "radio_button_checked"
                                        : "radio_button_unchecked"
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "v-list-item",
            [
              _c("v-skeleton-loader", {
                class: [_vm.$vuetify.breakpoint.smAndUp ? "w-3/4" : "w-full"],
                attrs: { type: "list-item-avatar-two-line" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }